
define('text!common/views/identity/saved-for-later-profile-link.html',[],function () { return '<li class="popup__item">\n    <a href="<%=idUrl%>/saved-for-later" class="brand-bar__item--action brand-bar__item--saved-for-later" data-link-name="Saved for Later">Saved for later</a>\n</li>\n';});

